import { Directive, HostListener, Input, Optional } from '@angular/core';
import { ButtonNamesGA } from '@cpak/consts';
import { TrackingContextService, TrackingService } from '@cpak/main-features-lib/services';
import { getModalName } from '@cpak/shared/utils';

@Directive({
  selector: '[cpakTrackSubmit]',
})
export class TrackSubmitDirective {
  @Input('cpakTrackSubmit') public buttonName: typeof ButtonNamesGA[keyof typeof ButtonNamesGA] =
    ButtonNamesGA.Undefined;

  private readonly modalName = getModalName();

  @HostListener('keydown.enter')
  public onSubmit(): void {
    this.tracking.trackClick({
      buttonName: this.buttonName,
      modalName: this.modalName,
      modeName: this.trackingContext?.currentMode ?? undefined,
      tabName: this.trackingContext?.currentTab ?? undefined,
    });
  }

  constructor(
    @Optional() private readonly trackingContext: TrackingContextService,
    private readonly tracking: TrackingService
  ) {}
}
